/* jshint esnext: true */
import { $document, APP_NAME, $body } from '../utils/environment';
import AbstractModule from './AbstractModule';

const MODULE_NAME = 'Contact';
const EVENT_NAMESPACE = `${APP_NAME}.${MODULE_NAME}`;

const EVENT = {
    CLICK: `click.${EVENT_NAMESPACE}`,
    TRIGGER: `hideButton.Contact`,
    CHANGENAV: `changeNav.Contact`
};

export default class extends AbstractModule {
    constructor(options) {
        super(options);

    }

    init() {
        $document.on(EVENT.TRIGGER,(e)=> {
            if(e.way === 'enter') {
                $body.addClass('on-contact');
            } else if(e.way === 'leave'){
                $body.removeClass('on-contact');
            }
        });

        $document.on(EVENT.CHANGENAV,(e)=> {
            if(e.way === 'enter') {
                $body.addClass('on-contact-change-nav');
            } else if(e.way === 'leave'){
                $body.removeClass('on-contact-change-nav');
            }
        });

        this.$el.on(EVENT.CLICK, '.js-button', (e) => {
            let target = $(e.currentTarget).data('target');
            $(target).triggerHandler({
                type: 'open.Form'
            });
        });

        $('.js-contact-menu-button').on(EVENT.CLICK,(e) => {
            $document.triggerHandler({
                type: 'close.Nav'
            });
        });
    }

    destroy() {
        this.$el.off(`.${EVENT_NAMESPACE}`);
        $body.removeClass('on-contact-change-nav');
        $body.removeClass('on-contact');

    }

}
